/**
 * Default limit to be used for search API queries.
 *
 * @format
 */

export const DEFAULT_SEARCH_LIMIT = 50;
/**
 * Maximum limit to be used for search API queries.
 */
export const MAX_SEARCH_LIMIT = 999;
